import Background from './Background';
import Process from './Process';

export default {
  components: {
    Background,
    Process
  }
};
